import type { FieldListItemTyped } from '#blokkli-build/generated-types'
import type { FieldListItem } from '#blokkli/types'

type UseParagraphVisiblity = {
  shouldRenderItem: (item: FieldListItem | FieldListItemTyped) => boolean
}

export function useParagraphVisiblity(): UseParagraphVisiblity {
  function shouldRenderItem(item: FieldListItem | FieldListItemTyped): boolean {
    const channelsValue = item.options?.publicationChannels

    if (
      channelsValue === undefined ||
      channelsValue === null ||
      typeof channelsValue !== 'string'
    ) {
      return true
    }

    const globallyHidden = item.options?.bkHiddenGlobally === '1'
    const isVisibleForChanel = channelsValue.includes('web')
    return !globallyHidden && isVisibleForChanel
  }

  return { shouldRenderItem }
}
